import Team from "@assets/icons/new/team.svg?react";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { teamDisplayProperties } from "@components/table/teams/teams-table-utils";
import { PopperProps, Stack, Tooltip, Typography } from "@mui/material";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { blue } from "@flat-ui";
import { withEllipsis } from "@styles/common-styles";
import { TeamNameTooltip } from "@components/table/teams/team-name-tooltip";

/** Time to wait between hover and open the dialog */
const enterDelay = 200;

interface Props {
  /** The team data to be displayed */
  team: FaroCoreApiTypes.Team;
}

/** Popper props to be used in the tooltip */
const tooltipPopperProps: Partial<PopperProps> = {
  sx: {
    "& .MuiTooltip-tooltip": {
      backgroundColor: "white",
      borderRadius: "4px",
      boxShadow: "0px 3px 3px 0px rgba(133, 146, 173, 0.20)",
    },
  },
};

/**
 * The TeamName component displays a team's group name and, if available, a description of the group.
 */
export function TeamName({ team }: Props): JSX.Element {
  return (
    <Tooltip
      enterDelay={enterDelay}
      enterNextDelay={enterDelay}
      placement="bottom"
      title={<TeamNameTooltip team={team} />}
      slotProps={{
        popper: tooltipPopperProps,
      }}
    >
      <Stack
        component="div"
        sx={{
          gap: "8px",
          flexDirection: "row",
          alignItems: "center",
          ...withEllipsis,
          "&:hover": {
            color: blue[500],
          },
        }}
      >
        <SphereAvatar
          icon={<Team />}
          size="small"
          shouldHideWhiteRim={true}
          backgroundColor={teamDisplayProperties[team.category.kind].color}
        />
        <Typography
          component={"var"}
          sx={{
            fontWeight: "bold",
            fontSize: "12px",
            ...withEllipsis,
          }}
        >
          {team.name}
        </Typography>
      </Stack>
    </Tooltip>
  );
}
